<template>
  <div class="by-center">
    <h6 class="text-h6 mt-8 mb-3">Договор оферты</h6>

    <div class="text-body-2">
      <p v-if="acquiring.data.contractOfferUrl">
        <a
            class="accent--text"
            download
            :href="acquiring.data.contractOfferUrl"
        >
          скачать
        </a>
      </p>

      <h4
        v-else
        class="red--text"
      >
        не загружен
      </h4>
    </div>

    <h6 class="text-h6 mt-10 mb-3">Порядок проведения оплат и возвратов</h6>

    <div class="text-body-2">
      <p v-if="acquiring.data.paymentReturnProcedureUrl">
        <a
            class="accent--text"
            download
            :href="acquiring.data.paymentReturnProcedureUrl"
        >
          скачать
        </a>
      </p>

      <h4
          v-else
          class="red--text"
      >
        не загружен
      </h4>
    </div>

    <h6 class="text-h6 mt-10 mb-3">Цены товаров и описание услуг</h6>

    <div class="text-body-2">
      <p v-if="acquiring.data.priceServiceDescriptionUrl">
        <a
            class="accent--text"
            download
            :href="acquiring.data.priceServiceDescriptionUrl"
        >
          скачать
        </a>
      </p>

      <h4
          v-else
          class="red--text"
      >
        не загружен
      </h4>
    </div>

    <div v-if="acquiring.data.privacyPolicyUrl">

      <h6 class="text-h6 mt-10 mb-3">Политика конфиденциальности</h6>

      <div class="text-body-2">
        <p>
          <a
            :href="acquiring.data.privacyPolicyUrl"
            class="accent--text"
            download
          >
            скачать
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {getAcquiring} from '@/composables/acquiring'

export default {
  name: 'AcquiringDocuments',
  computed: {
    acquiring: getAcquiring
  }
}
</script>

<style scoped lang="scss">
.decimal-list li {
  list-style: decimal;
}
.symbol-list li {
  list-style: lower-latin;
}
.image-block {
  align-items: center;
  margin: -10px;
}
.p-method {
  display: block;
  margin: 0 auto;
  max-height: 40px;
}
</style>
